module.exports = __webpack_public_path__ + "img/training-outer.10543eb9.png";